var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMallDistribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-distribution_svg__a",
    d: "M7.1 6.1H11V4.7c0-1.1-.9-2-2-2s-2 .9-2 2v1.4zM6 6.1V4.7C6 3 7.4 1.6 9.1 1.6s3.1 1.4 3.1 3.1v1.4H15l.7 9.2c.1.6-.4 1.2-1 1.2H3.6c-.6 0-1.1-.5-1.1-1.1v-.1l.7-9.2H6zm6.2 2.1c.3.2.6.6.6 1 0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1c0-.4.2-.8.6-1v-1H7.1v1c.3.2.6.6.6 1 0 .6-.5 1.1-1.1 1.1s-1.2-.5-1.2-1.1c0-.4.2-.8.6-1v-1H4.2l-.7 8.2h11.1L14 7.2h-1.8v1z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "mall-distribution_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-distribution_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mall-distribution_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-distribution_svg__c",
    d: "M-23.9-887.8h1360v1096h-1360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mall-distribution_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-distribution_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#mall-distribution_svg__d)",
    d: "M-2.6-3.4h23.3v24.9H-2.6z"
  }))));
}

export default SvgMallDistribution;